// Fog measured as flat (x/z) distance from the player, for Explore & Craft.
// Three.js fogs by view depth from the camera, which fogs the player's own surroundings when the camera is zoomed
// out and lets the edge of the loaded world show at the sides of a wide screen. While `fogAroundPlayer` is on, every
// built-in material instead fogs by the horizontal distance of each pixel from the player, so the same circle stays
// clear at any zoom or angle. Adventure and Blitz keep three.js's usual depth fog (`fogFromCamera`).
// The chunks are patched once, before any material compiles (main.js imports this first); the one shared uniform is
// added to every program through Material.prototype.onBeforeCompile, so updating it needs no recompiles.
import * as THREE from 'three';

const centre = new THREE.Vector4(0, 0, 0, 0); // x, z: the player; w: 1 = flat distance from them, 0 = depth
const uniform = { value: centre };

THREE.ShaderChunk.fog_pars_vertex = /* glsl */ `
#ifdef USE_FOG
	varying float vFogDepth;
	varying vec2 vFogXZ;
#endif
`;
// The view matrix is rigid, so the world position is R^T (v - t). The distance itself is taken per pixel: a long
// merged block face passing the player would interpolate it badly.
THREE.ShaderChunk.fog_vertex = /* glsl */ `
#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
	vFogXZ = ( transpose( mat3( viewMatrix ) ) * ( mvPosition.xyz - viewMatrix[ 3 ].xyz ) ).xz;
#endif
`;
THREE.ShaderChunk.fog_pars_fragment = /* glsl */ `
#ifdef USE_FOG
	uniform vec3 fogColor;
	uniform vec4 fogCentre;
	varying float vFogDepth;
	varying vec2 vFogXZ;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif
`;
THREE.ShaderChunk.fog_fragment = /* glsl */ `
#ifdef USE_FOG
	float fogDist = fogCentre.w > 0.5 ? length( vFogXZ - fogCentre.xz ) : vFogDepth;
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDist * fogDist );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, fogDist );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif
`;
THREE.Material.prototype.onBeforeCompile = function (shader) {
  shader.uniforms.fogCentre = uniform;
};

export function fogAroundPlayer(x, z) {
  centre.set(x, 0, z, 1);
}
export function fogFromCamera() {
  centre.w = 0;
}
export const fogState = () => ({ x: centre.x, z: centre.z, flat: centre.w > 0.5 });
